import { render, staticRenderFns } from "./LeftPaneChatQueue.vue?vue&type=template&id=04a0cc16"
import script from "./LeftPaneChatQueue.vue?vue&type=script&lang=js"
export * from "./LeftPaneChatQueue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports